import type { IResolverCreateCandidateChallenge } from "@complex/Challenges/logics/types";
import { AutocompleteForm } from "@inputs/hook-form";
import { useLayoutEffect } from "react";
import { type Control, type UseFormSetValue, useWatch } from "react-hook-form";
import type { IFormCreateCandidateChallenge } from "../logics";

export interface IAutocompleteObjectivesProps {
  control: Control<IFormCreateCandidateChallenge, void, IResolverCreateCandidateChallenge>;
  setValue: UseFormSetValue<IFormCreateCandidateChallenge>;
}

export const AutocompleteObjectives = ({ control, setValue }: IAutocompleteObjectivesProps) => {
  const challenge = useWatch({ control, name: "challenge" });

  // biome-ignore lint/correctness/useExhaustiveDependencies: Clear objective on challenge change
  useLayoutEffect(() => {
    setValue("objective", null);
  }, [challenge]);

  return (
    <AutocompleteForm
      control={control}
      name="objective"
      options={challenge?.objectives.filter((obj) => obj.active) ?? []}
      getOptionKey={(option) => option._id}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      disabled={challenge === null}
      label="Type d'objectif *"
      size="small"
      fullWidth
    />
  );
};
